import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import TopNav from "../components/TopNav.jsx";

export default function ManualPage() {
  const [m, setM] = useState(null);
  useEffect(() => { api.manual().then(setM).catch(() => setM(null)); }, []);
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain relative">
      <TopNav />
      <div className="mx-auto max-w-4xl px-4 md:px-8 py-16">
        <div className="text-xs uppercase tracking-[0.2em] text-sage-muted mb-2">The Manual</div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter uppercase mb-6">
          Everything I had to teach myself.
        </h1>
        {m && (
          <>
            <blockquote className="border-l-2 border-sage-accent pl-6 py-2 text-lg text-sage-text sage-prose max-w-3xl mb-4" data-testid="manual-quote">
              {m.quote}
            </blockquote>
            <div className="text-[10px] uppercase tracking-[0.15em] text-sage-accent mb-8">{m.attribution}</div>
            <p className="text-base text-sage-muted sage-prose max-w-3xl mb-12">{m.intro}</p>
            <div className="space-y-6">
              {m.chapters.map((c, idx) => (
                <div key={c.key} className="border border-sage-border p-6" data-testid={`manual-chapter-${c.key}`}>
                  <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint tabular-nums mb-1">§ {String(idx + 1).padStart(2, "0")}</div>
                  <div className="text-xl font-bold uppercase tracking-tight text-sage-text mb-2">{c.title}</div>
                  <div className="text-sm text-sage-muted sage-prose mb-4">{c.summary}</div>
                  {c.prereqs?.length > 0 && (
                    <>
                      <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint mb-1">You need</div>
                      <ul className="text-xs text-sage-muted mb-4 space-y-1">
                        {c.prereqs.map((p, i) => <li key={i}>· {p}</li>)}
                      </ul>
                    </>
                  )}
                  <div className="text-[10px] uppercase tracking-[0.15em] text-sage-faint mb-1">Steps</div>
                  <ol className="text-sm text-sage-muted sage-prose space-y-2 list-decimal ml-6">
                    {c.steps.map((s, i) => <li key={i}>{s}</li>)}
                  </ol>
                </div>
              ))}
            </div>
            <div className="mt-12 text-center">
              <Link to="/promises" className="text-[10px] uppercase tracking-[0.15em] border border-sage-accent text-sage-accent px-6 py-3 hover:bg-sage-accent hover:text-sage-bg">
                Now the promises →
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
